import React, { LegacyRef } from "react";
import { isMobile } from "react-device-detect";
import "./Input.scss";

export enum InputType {
  Text,
  Password,
  Email,
}

export interface IInputProps {
  multiline?: boolean;
  type?: InputType;
  label?: string;
  defaultValue?: string;
  onTextChange?: (text: string) => void;
}

const Input = (props: IInputProps, ref: LegacyRef<HTMLInputElement>) => {
  const { label, defaultValue, type, onTextChange } = props;
  const [focused, setFocused] = React.useState(false);

  const typeString = type === InputType.Password ? "password" : type === InputType.Email ? "email" : "text";

  let text: string = "";

  const onKeyDown = () => {
    if ((ref as any)?.current?.value !== text) {
      text = (ref as any)?.current?.value;
      if (onTextChange) onTextChange(text);
    }
  };

  return (
    <div className={`input-main${isMobile ? " input-main-mobile" : ""}`}>
      <span className={`input-label${focused ? " input-label-focused" : ""}`}>{label}</span>
      <input
        data-lpignore={true}
        className={`input${isMobile ? ' input-mobile"' : ""}`}
        ref={ref}
        type={typeString}
        placeholder={label}
        defaultValue={defaultValue}
        onKeyDown={onKeyDown}
        onFocus={() => setFocused(true)}
        onBlur={() => setFocused(false)}
        autoComplete="off"
      ></input>
    </div>
  );
};

export default React.forwardRef(Input);
